import Create from "./create";
import Deposit from "./deposit";
import Withdraw from "./withdraw";

const PAWS_SERVICE = { ...Create, ...Deposit, ...Withdraw };

export default PAWS_SERVICE;
